<template>
  <v-flex xs-12>
    <v-card>
      <v-card-title color="blue lighten-2">
        <h3>
          {{detalhe.aluno.first_name + ' ' + detalhe.aluno.last_name}}
        </h3> 
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-layout row flex class="pl-0">
            <!-- Avatar do Aluno -->
            <v-flex xs2>
              <v-avatar class="text-xs-center" size="80">
              <img :src="pictureUrl(detalhe.aluno.profilePic)" >
              </v-avatar>
            </v-flex>

            <!-- Implementação alternativa -->

            <v-flex xs10>
              <h4><strong>{{detalhe.titulo}} </strong></h4>
              <profile-text title='Planejado' 
                v-model='detalhe.ativ_planejada'
                :editing='isediting'
                last
                class='mb-5'
              input-type='multilinetext'></profile-text>
              <profile-text title='Ocorrido' 
                v-model='detalhe.ativ_ocorrida'
                :editing='isediting'
                class='mb-5'
                last
              input-type='multilinetext'></profile-text>
              <profile-text v-if="canSeeComment" title='Comentário' 
                v-model='detalhe.comentario'
                class='mb-5'
                :editing='isediting'
              input-type='multilinetext'></profile-text>
            </v-flex>
            
            <!--
            Exibição dos detalhes
            <v-flex xs-10 v-if='!isediting.includes(detalhe.id)'>
              <h4><strong>{{detalhe.titulo}} </strong></h4>
              <p><strong>Planejado:</strong> {{detalhe.ativ_planejada}}</p>
              <p><strong>Ocorrido:</strong> {{detalhe.ativ_ocorrida}}</p>
              <p v-if="canSeeComment"><strong>Comentário:</strong> {{detalhe.comentario}}</p>
            </v-flex>
            
            Edição dos detalhe
            <v-flex xs-10 v-else>
              <h4><strong>{{detalhe.titulo}} </strong></h4>
              <p><strong>Planejado:</strong></p>
              <textarea 
              id="comment"
              class="form-control"
              v-model="tempData.ativ_planejada">
              </textarea>
              <p><strong>Ocorrido:</strong></p>
              <textarea 
              id="comment"
              class="form-control"
              v-model="tempData.ativ_ocorrida">
              </textarea>
              <div  v-if="canSeeComment">
                <p>
                    <strong>Comentário:</strong></p>
                <textarea 
                id="comment"
                class="form-control"
                v-model="tempData.comentario">
                </textarea>
              </div>
            </v-flex>
          -->
          
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions v-if='false'>
        <!-- ESQUERDA -->
        <!-- input de data para reagendamento -->
        <v-layout row v-if="canReschedule && isrescheduling"> 
          <v-flex sm5>
            <v-menu
              ref="menu2"
              :close-on-content-click="false"
              v-model="menu2"
              :nudge-right="40"
              :return-value.sync="rescheduleinfo.date"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="rescheduleinfo.date"
                label="Data"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="rescheduleinfo.date" 
              locale="pt-br"
              @input="$refs.menu2.save(rescheduleinfo.date)"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm5>
            <v-menu
              ref="menu"
              :close-on-content-click="false"
              v-model="menu"
              :nudge-right="40"
              :return-value.sync="rescheduleinfo.time"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="rescheduleinfo.time"
                label="Hora"
                prepend-icon="access_time"
                readonly
              ></v-text-field>
              <v-time-picker v-model="rescheduleinfo.time"
              @change="$refs.menu.save(rescheduleinfo.time)"></v-time-picker>
            </v-menu>
          </v-flex>
        </v-layout>

        <v-spacer></v-spacer>
        <!-- DIREITA -->

        <span v-if="canReschedule && !isediting">
          <v-btn v-if='!isrescheduling' 
          class="btn btn-primary"
          @click.native='startReschedule(detalhe)'>
              Reagendar
          </v-btn>
          <v-btn v-if='isrescheduling' 
          color="red darken-1" flat
          @click.native='removeReschedule(detalhe.id)'>
              Cancelar
          </v-btn>
          <v-btn v-if='isrescheduling' 
          color="green darken-1" flat
          @click.native='saveReschedule(detalhe)'>
              Salvar
          </v-btn>
      </span>
      <span v-if="canEdit && !isrescheduling">
          <v-btn 
          v-if='((!isediting) & (isMediador(teacher.username)))' 
          color="blue darken-1" flat
          @click.native='startEdit(detalhe)'>
              Editar
          </v-btn>
          <v-btn v-if='isediting' 
          color="red darken-1" flat
          @click.native='removeElement(detalhe.id)'>
              Cancelar
          </v-btn>
          <v-btn v-if='isediting' 
          color="green darken-1" flat
          @click.native='saveDetails(detalhe)'>
              Salvar
          </v-btn>
        </span>

      </v-card-actions>


    </v-card>
  </v-flex>
</template>

<script>
import api from '@/api'
import ProfileText from '@/components/reusable/ProfileText.vue'

export default {
  components: {
    ProfileText
  },
  data () {
    return {
      rescheduling: false,
      isediting: false,
      isrescheduling: false,
      rescheduleinfo: {}
    }
  },
  props: {
    detalhe: {},
    canReschedule: false

  },
  methods: {
    pictureUrl (pic) {
      if (pic === null) {
        return ''
      } else {
        return pic
      }
    },
    reagendarIndividual () {
      this.rescheduleinfo.start = this.rescheduleinfo.date + ' ' + this.rescheduleinfo.time
      let timedelta = window.moment.duration(window.moment(this.contextEvent.dt_fim).diff(window.moment(this.contextEvent.dt_inicio)))
      let detalheid = this.reschedulingDetail.id
      var payload = {
        'dt_inicio': this.rescheduleinfo.start,
        'dt_fim': window.moment(this.rescheduleinfo.start).add(timedelta).format('YYYY-MM-DDTHH:mm'),
        'userlist': [this.reschedulingDetail.aluno.username],
        'title': this.reschedulingDetail.aluno.username.concat(' - Reagendamento'),
        'unidade': this.contextEvent.unidade
      }
      api.request('POST', 'aulas/', payload).then((response) => {
            // element = respon      rescheduleinfo: {},      rescheduleinfo: {},      rescheduleinfo: {},      rescheduleinfo: {},      rescheduleinfo: {},se.data
        api.request('DELETE', 'auladetail/' + detalheid + '/').then((response) => {
          this.confirmationCancelar()
          this.$refs.calendar.$emit('refetch-events')
          this.modalClose()
        })
      }).catch(function (error) {
        console.log(error)
      })
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/pages/Calendario/componentes/CardAluno.vue